export const INVALIDATE_TOKEN = 'INVALIDATE_TOKEN';
export const RECEIVE_TOKEN = 'RECEIVE_TOKEN';
export const REQUEST_TOKEN_ERROR = 'REQUEST_TOKEN_ERROR';
export const REQUEST_TOKEN = 'REQUEST_TOKEN';
